import { createSelector } from 'reselect';

export const selectFavoriteStores = state => state.favoriteStores;
export const selectFavoriteStoresConfig =
  createSelector(selectFavoriteStores, favoriteStores => favoriteStores.config);
export const selectFavoriteStoresMerchants =
  createSelector(selectFavoriteStores, favoriteStores => favoriteStores.merchants);
